import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function AudienceSection() {
  const forWhom = ['Adultos de más de 50 años que sienten que su sueño se ha vuelto frágil.', 'Personas cansadas de la dependencia y los efectos secundarios de los somníferos.', 'Quienes sufren de rumiación —pensamientos circulares— apenas apagan la luz.', 'Quienes viven en climas cálidos y sienten que el calor les roba el descanso.'];
  const notForWhom = ['Personas que buscan una cura mágica de una noche sin cambiar un solo hábito.', 'Quienes tienen condiciones médicas respiratorias graves como apnea del sueño que requieren intervención clínica.', 'Personas que prefieren seguir dependiendo de químicos en lugar de entender su propia biología.'];
  return <section className="py-24 px-4 md:px-8 bg-nightBlueLighter" data-id="element-2">
      <div className="max-w-5xl mx-auto" data-id="element-3">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-4">
          {/* FOR */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-nightBlue p-8 md:p-10 rounded-3xl border-t-4 border-teal shadow-xl" data-id="element-5">
            <h3 className="font-montserrat font-semibold text-2xl text-warmWhite mb-8 flex items-center gap-3" data-id="element-6">
              <div className="bg-teal/20 p-2 rounded-full" data-id="element-7">
                <CheckIcon className="w-6 h-6 text-teal" data-id="element-8" />
              </div>
              Esto ES para ti si:
            </h3>
            <ul className="space-y-6" data-id="element-9">
              {forWhom.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-10">
                  <CheckIcon className="w-5 h-5 text-teal flex-shrink-0 mt-1" data-id="element-11" />
                  <span className="font-lato text-base text-warmWhite/90" data-id="element-12">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* NOT FOR */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-nightBlue p-8 md:p-10 rounded-3xl border-t-4 border-silver/50 shadow-xl opacity-90" data-id="element-13">
            <h3 className="font-montserrat font-semibold text-2xl text-warmWhite mb-8 flex items-center gap-3" data-id="element-14">
              <div className="bg-silver/10 p-2 rounded-full" data-id="element-15">
                <XIcon className="w-6 h-6 text-silver" data-id="element-16" />
              </div>
              Esto NO es para ti si:
            </h3>
            <ul className="space-y-6" data-id="element-17">
              {notForWhom.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-18">
                  <XIcon className="w-5 h-5 text-silver flex-shrink-0 mt-1" data-id="element-19" />
                  <span className="font-lato text-base text-warmWhite/70" data-id="element-20">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}